import React from 'react';
import Settings from '../components/Settings/Settings';

const SettingsPage = () => {
  return <Settings />;
};

export default SettingsPage;
